// @ts-nocheck
import React from "react";
import { useParams, useNavigate } from "@tanstack/react-router";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import StandardDetailLayout from "@/layouts/StandardDetailLayout";
import { trpcClient } from "@/lib/trpc";
import { QCMaterialForm } from "./QCMaterialForm";

export default function QCMaterialEdit() {
  const { checkId } = useParams({ strict: false }) as { checkId: string };
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { data: item, isLoading } = useQuery({
    queryKey: ["qcMaterial", checkId],
    queryFn: async () => (trpcClient as any).qcMaterials.getById.query({ id: checkId }),
    enabled: !!checkId,
  });

  const handleSubmit = async (data: any) => {
    try {
      await (trpcClient as any).qcMaterials.update.mutate({ id: checkId, data });
      toast.success("Cập nhật biên bản kiểm tra vật tư (IQC) thành công!");
      await queryClient.invalidateQueries({ queryKey: ["qcMaterial", checkId] });
      await queryClient.invalidateQueries({ queryKey: ["qc-materials-all"] });
      navigate({
        to: "/qc-materials/$checkId",
        params: { checkId },
        replace: true,
      });
    } catch (err: any) {
      toast.error(err?.message || "Lỗi khi cập nhật phiếu IQC");
      throw err;
    }
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Loader2 className="h-8 w-8 animate-spin text-indigo-600" />
      </div>
    );
  }

  return (
    <StandardDetailLayout
      breadcrumbs={[
        { label: "Kiểm tra Vật tư (IQC)", to: "/qc-materials" },
        { label: item?.materialQcId || checkId, to: `/qc-materials/${checkId}` },
        { label: "Chỉnh sửa" },
      ]}
      title={`Sửa ${item?.materialQcId || ""}`}
      onBack={() => navigate({ to: "/qc-materials/$checkId", params: { checkId } })}
      actions={
        <div className="flex items-center gap-2">
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={() => navigate({ to: "/qc-materials/$checkId", params: { checkId } })}
          >
            Hủy
          </Button>
          <Button
            type="submit"
            size="sm"
            className="bg-indigo-600 hover:bg-indigo-700 text-white font-semibold"
            onClick={() => {
              const formEl = document.getElementById("qc-material-canonical-form") as HTMLFormElement | null;
              formEl?.requestSubmit();
            }}
          >
            <Save className="w-4 h-4 mr-1.5" /> Cập Nhật Phiếu IQC
          </Button>
        </div>
      }
    >
      <QCMaterialForm
        initialData={item}
        onSubmit={handleSubmit}
        onCancel={() => navigate({ to: "/qc-materials/$checkId", params: { checkId } })}
      />
    </StandardDetailLayout>
  );
}
